<template>
  <div class="img-preview-wrp" v-show="visible">
    <div class="modal" @touchstart="onClose"></div>
    <img :style="{transform: `scale(${scale}) translate(${translateX}px, ${translateY}px)`}" id="previewImg" ref="previewImgRef" :src="img" class="img-wrp" />
  </div>
</template>

<script>
import Hammer from 'hammerjs'
export default {
  props: {
    img: {
      type: String
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      hammerInstance: undefined,
      scale: 1,
      translateX: 0,
      translateY: 0
    }
  },
  watch: {
    visible () {
      if (!this.visible) {
        this.scale = 1
        this.translateX = 0
        this.translateY = 0
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    onClose () {
      this.$emit('onClose')
    },
    init () {
      let dom = this.$refs.previewImgRef
      this.hammerInstance = new Hammer(dom)
      this.hammerInstance.get('pinch').set({ enable: true })
      this.hammerInstance.on('panmove', (e) => {
        this.translateX = e.deltaX
        this.translateY = e.deltaY
      })
      this.hammerInstance.on('pinchin', (e) => {
        this.scale = e.scale
      })
      this.hammerInstance.on('pinchout', (e) => {
        this.scale = e.scale
      })
    }
  }
}
</script>

<style scoped lang="less">
.img-preview-wrp {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 2100;
  top: 0;
  left: 0;
  background: rgba(0,0,0,0.5);
  .modal {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
  }
  .img-wrp {
    width: 100%;
    height: auto;
    position: absolute;
    z-index: 3;
    top: 20%;
    left: 0;
  }
}
</style>
